// This is created for a sales event only, remove after its concluded
// https://shapr3d.atlassian.net/browse/COL2-327
// (that's why its completely self contained, so its easier to remove,
// just delete this file and remove every caller (which will be build issues after the deletion of this file))

import { Button } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { Environment, environment } from "../../config";

const PROD_BANNER_VIEWLINKS = [
  "uHjzYDWeff2n5jcHsnlEF",
  "pc0Hoi2E1QB04Y2It8F0t",
  "qFQJbmpcuqo5aoVboKEAf",
  "8vp5W9A7W5bdUEHFZTb2C",
];
const STAGE_BANNER_VIEWLINKS = ["n_8AEV-wpfIv25xfme52V"];

export const TemporarySalesBanner = () => {
  const { viewLink = "" } = useParams();
  if (
    (environment === Environment.PROD && !PROD_BANNER_VIEWLINKS.includes(viewLink)) ||
    (environment !== Environment.PROD && !STAGE_BANNER_VIEWLINKS.includes(viewLink))
  ) {
    return;
  }

  return (
    <div
      style={{
        boxShadow: "0px 16px 32px -4px #00000033",
        background: "white",
        position: "fixed",
        bottom: "0",
        maxWidth: "428px",
        width: "calc(100% - 32px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "16px auto",
        padding: "16px",
        boxSizing: "border-box",
        borderRadius: "8px",
        zIndex: "9999",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: "10px",
        }}
      >
        <span>Let&apos;s talk about getting your Delonghi team designing better with Shapr3D</span>
        <Button
          variant="primary"
          onClick={() => {
            window.open("https://www.shapr3d.com/contact-sales", "_blank");
          }}
        >
          Contact us
        </Button>
      </div>
    </div>
  );
};
